import React, { useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import "./headerRanking.css";
import ListBuilderRating from "../Ranking/listBuilderRanking";
import { Skeleton } from "antd";
import ListProjectRating from "../Ranking/listProjectRanking";
import ListProjectVideoRating from "../Ranking/listVideoRanking";

const STORAGE_KEY = "ranking_header_tab";

const HeaderRanking = () => {
  const [selectedTable, setSelectedTable] = useState(
    localStorage.getItem(STORAGE_KEY) || "ranking_builder_list"
  );

  const [loading, setLoading] = useState(false);

  const handleTableSelection = (table) => {
    if (table === selectedTable || loading) return;


    setLoading(true);
    setSelectedTable(table);
    localStorage.setItem(STORAGE_KEY, table);

    setTimeout(() => {
      setLoading(false);
    }, 400);
  };

  return (
    <MainLayout>
      <div className="dealsAndOffers-container">
        <div className="bg-white border-10 padding-10 shadow-box">
          <div className="hover_panel">
            <h4
              className={selectedTable === "ranking_builder_list" ? "clicked" : ""}
              onClick={() => handleTableSelection("ranking_builder_list")}
            >
              Builder List
            </h4>
            <h4
              className={selectedTable === "ranking_project_list" ? "clicked" : ""}
              onClick={() => handleTableSelection("ranking_project_list")}
            >
              Project List
            </h4>
            <h4
              className={selectedTable === "ranking_video_list" ? "clicked" : ""}
              onClick={() => handleTableSelection("ranking_video_list")}
            >
              Reel List
            </h4>
          </div>
        </div>

        {loading && (
          <div className="tab-loader">
            <Skeleton active paragraph={{ rows: 6 }} />
          </div>
        )}

        <div style={{ display: loading ? "none" : "block" }} className="fade-wrapper">
          <div
            className="fade-tab"
            style={{ display: selectedTable === "ranking_builder_list" ? "block" : "none" }}
          >
            <ListBuilderRating />
          </div>

          <div
            className="fade-tab"
            style={{ display: selectedTable === "ranking_project_list" ? "block" : "none" }}
          >
            <ListProjectRating />
          </div>

          <div
            className="fade-tab"
            style={{ display: selectedTable === "ranking_video_list" ? "block" : "none" }}
          >
            <ListProjectVideoRating />
          </div>
        </div>
    </div>
    </MainLayout >
  );
};

export default HeaderRanking;
